import ingredient from '@js/store/inventory-fnb/modules/ingredient';

export default {
    created() {
        if (!this.$store.hasModule('ingredient')) {
            this.$store.registerModule('ingredient', ingredient);
        }
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory-fnb/ingredient/store-mixin.js